import React, { useState, useEffect, useRef } from 'react';
import { connectWebSocket } from './WebSocketService';
import { AiOutlineSend } from 'react-icons/ai';
import { HiOutlineSpeakerWave } from 'react-icons/hi2'
import { BsMic } from 'react-icons/bs'
import Header from './Components/Header';
import LoginPage from './Components/LoginPage';
import RegisterPage from './Components/RegisterPage';
import axios from 'axios';


const API = process.env.REACT_APP_BACKEND_URL
function App() {
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [loading, setLoading] = useState(false);
  let themeMode = window.localStorage.getItem("mode")
  const [mode, setMode] = useState(themeMode || 'night');
  const [history, setHistory] = useState({internal:[], visible:[]})
  const chatContainerRef = useRef(null);
  const [user, setUser] = useState(null);
  let userId = window.localStorage.getItem("userId")
  const [isLoggedIn, setIsLoggedIn] = useState(userId?true:false);
  const [btnToggle, setBtnToggle] = useState('NA')
  const [errMsg, setErrMsg] = useState('')

  useEffect(()=> {
    setErrMsg('')
  }, [btnToggle])
  const handleLogin = async (email, password) => {
    const response = await axios.post(`${API}/api/login`, { email, password });
    setUser(response.data); 
    if (!response.data.username) return setErrMsg(response?.data?.error || "Something went wrong")
    window.localStorage.setItem("userId", response.data.email)
    setIsLoggedIn(true)
    setErrMsg('')
  
  };

  const handleRegister = async (username, email, password) => {
    const response = await axios.post(`${API}/api/register`, { username, email, password });
    setUser(response.data);
    if (!response.data.username) return setErrMsg(response?.data?.error || "Something went wrong")
    window.localStorage.setItem("userId", response.data.email)
    setIsLoggedIn(true);
    setErrMsg('')
  };
  
  const handleLimit = async (email) => {
    const response = await axios.post(`${API}/api/update-limit`, { email });
    setUser(response.data);
    if (!response.data.username) return;
  }

  const getUser = async () => {
    let email = window.localStorage.getItem("userId")
    if(!email || email === undefined) return;
    const response = await axios.post(`${API}/api/get-user`, { email });
    setUser(response.data);
    if (!response.data.username) return
    window.localStorage.setItem("userId", response.data.email)
    setIsLoggedIn(true);
  }

  useEffect(() => {
    getUser()
  }, []);

  const handleReceiveMessage = (userInput, newHistory) => {
    setHistory(newHistory)
    setMessages([...messages, { text: userInput, isUser: true }, { text: newHistory.visible[newHistory.visible.length-1][1], isUser: false }]);
    scrollToBottom();
  };

  const handleSendMessage = async ({inputs=""}) => {
    try {
    
    if (user?.limit === 0) return setErrMsg('Message Limit Over');
    if (WebSocket.OPEN !== 1) return setErrMsg('WebSocket is not connected');

    if (inputMessage.trim() === '' && !inputs) return setErrMsg('Please write something to send')
    setErrMsg('')
    
    setLoading(true);

    await new Promise(resolve => setTimeout(resolve, 1000));
    await setMessages([...messages, { text: inputMessage || inputs, isUser: true }]);

    setLoading(false);
    setInputMessage('');
    scrollToBottom();

    await connectWebSocket(inputMessage || inputs, history, handleReceiveMessage);
    
    } catch (error) {
      setErrMsg('Something went wrong')
    }
  };

  useEffect(()=> {
    if(messages.length>0 && messages?.length%2===0 && user?.email) {
    handleLimit(user.email);
    console.log('run')
    }
  }, [messages?.length, user?.email])

  const toggleMode = () => {
    setMode(mode === 'day' ? 'night' : 'day');
    window.localStorage.setItem("mode", mode === 'day' ? 'night' : 'day')
  };

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  };

  const onSpeak = async (message)=> {
    console.log(message)
    const utterance = new SpeechSynthesisUtterance(message);
    const voices = await window.speechSynthesis.getVoices();
    const selectedVoice = await voices.find(voice => voice.name === 'Google UK English Female');
    utterance.voice = selectedVoice;
    console.log(utterance);
    await window.speechSynthesis.speak(utterance);
    return;
  }


  const onListen = () => {
    if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognition = new SpeechRecognition(); 
      recognition.lang = 'en-US'; 
      recognition.onresult = async (event) => {
        const transcript = event.results[0][0].transcript; 
        console.log('Recognized:', transcript);
        await setInputMessage(transcript)
        await handleSendMessage({inputs:transcript})
      };
      recognition.start(); 
    } else {
      console.log('Speech recognition not supported by your browser.');
    }
  }

  useEffect(()=> {
    const utterance = new SpeechSynthesisUtterance('');
    const voices =  window.speechSynthesis.getVoices();
    const selectedVoice = voices.find(voice => voice.name === 'Google UK English Female');
    utterance.voice = selectedVoice;
  },[])

  const mapObj = { "&lt;/s&gt;": "", "&#x27;": "", "&lt;/p&gt;": "", "&quot;": '"', "&apos;": "'", "&amp;": "&", "&lt;": "","&gt;":"" }

  var re = new RegExp(Object.keys(mapObj).join("|"), "gi");

  async function handleLogout() {
    window.localStorage.removeItem('userId');
    setIsLoggedIn(false)
    setUser(null)
  }

  return (
    <div lang="en" className={`flex flex-col min-h-screen ${mode === 'night' ? 'bg-gray-900' : 'bg-gray-100'}`}>
      <Header mode={mode} toggleMode={toggleMode} user={user} handleLogout={handleLogout}/>
      {!isLoggedIn ? (
        <div className="flex justify-center items-center h-[58vh]">
          <div>
            {btnToggle === "login" ? <LoginPage handleLogin={handleLogin} mode={mode} setBtnToggle={setBtnToggle} errMsg={errMsg} /> : btnToggle === "register" ? <RegisterPage handleRegister={handleRegister} mode={mode} setBtnToggle={setBtnToggle} errMsg={errMsg}/>:<>
              <div className='ml-auto items-center pl-[3.5rem]'><img
                src={"bot.jpg"}
                alt="logo"
                className="w-20 lg:h-20 rounded-full mr-4 mb-4"
              /></div>
              <div>
              <button className="bg-blue-500 text-white px-4 py-2 rounded m-2" onClick={()=>setBtnToggle('login')}>
                Login
              </button>
              <button className="bg-green-500 text-white px-4 py-2 rounded m-2" onClick={() => setBtnToggle('register')}>
                Register
              </button>
              </div>
            </>}
          </div>
        </div>
      ):(
      <div className="flex-1 px-12 lg:px-72 pt-20">
        <div
          ref={chatContainerRef}
          className="h-[50vh] overflow-y-auto mb-4"
        >
          {messages.map((message, index) => (
            <div
              key={index}
              className={`mb-2 p-3 ${message.isUser
                  ? 'flex justify-end' 
                  : 'flex justify-start' 
                }`}
            >
              
                {!message.isUser && <img
                  src={message.isUser?"user.png":"bot.jpg"}
                  alt="User Profile"
                  className="w-8 h-8 rounded-full mr-2"
                />}
              {/* {
                message.isUser && <button className={`mx-4 mt-auto p-2 rounded-full ${mode === 'night' ? 'bg-gray-600 text-gray-100' : 'bg-gray-300 text-gray-700'}`} onClick={() => onSpeak(message.text)}><HiOutlineSpeakerWave/></button>
              } */}
              
              <div
                className={` py-2 px-3 ${message.isUser
                  ? 'bg-blue-500 text-white rounded-br-lg rounded-l-lg'
                  : `${mode === 'night' ? 'bg-gray-700 text-gray-100' : 'bg-gray-300 text-gray-700'} rounded-r-lg rounded-bl-lg`
                  }`}
              >
                
                <p>{
                  (
                    message.text.includes("`") ? (
                      <code style={{ whiteSpace: 'pre-wrap' }}>
                        {message.text.replace(/`([^`]*)`/g, (_, code) => code)}
                      </code>
                    ) : (
                      message.text.replace(re, (matched) => mapObj[matched])
                    )
                  ) 
                  
                }</p>
                
                

              </div>
              {message.isUser && <img
                src={message.isUser ? "user.png" : "bot.jpg"}
                alt="User Profile"
                className="w-8 h-8 rounded-full ml-2"
              />}
              {
                !message.isUser && <button className={`mx-4 mt-auto p-2 rounded-full ${mode === 'night' ? 'bg-gray-600 text-gray-100' : 'bg-gray-300 text-gray-700'}`} onClick={() => onSpeak(message.text)}><HiOutlineSpeakerWave /></button>
              }
            </div>

          ))}
          {loading && (
            <div className={mode === "night" ? "text-gray-100 text-center py-2" : "text-gray-500 text-center py-2"}>
              AI is typing...
            </div>
          )}
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSendMessage({inputs:''});
          }}
          className="border-t border-gray-200"
        >
              
          <div className="flex items-center p-2">
            
            <input
              type="text"
              placeholder="Send a message..."
              disabled={user?.limit === 0?true:false}
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              className={`flex-1  ${mode === "night" ? 'bg-gray-700 text-gray-50' :'bg-gray-300 text-gray-700'} border border-gray-300 rounded p-2 focus:outline-none`}
            />
            <p
              className="bg-blue-500 text-white px-3 py-3 rounded-full ml-2" onClick={() => onListen()}
            >
              <BsMic />
            </p>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-3 rounded ml-2"
            >
              <AiOutlineSend />
            </button>

          </div>
              <p className='text-[#c34444]'>{errMsg}</p>
        </form>
      </div>
      )}
    </div>
  );
}

export default App;
